<template>
  <div>
    <div class="head"
         :style='`width:${width.hole};height:${height.head}`'>
      <img src="../../../assets/imgs/top_title_bg.png"
           alt=""
           class="headImg"
           :style="`top:${-23*$store.state.ratio.hole}px;`">
      <div class="head-item"></div>
      <div class="head-item"
           :style="`font-size:${28*$store.state.ratio.hole}px;line-height:${70*$store.state.ratio.hole}px`">气象监控中心</div>
      <div class="head-item">
        <img src="../../../assets/imgs/closeLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='$store.state.lock' />
        <img src="../../../assets/imgs/openLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='!$store.state.lock' />
      </div>
    </div>
    <div :style='`width:${width.hole};height:${height.hole}`'
         class="flex">
      <div class='chart'
           :style='`height:${height.hole}`'>
        <div :style="`font-size:${24*$store.state.ratio.hole}px`"></div>
        <div class="flex">
          <div class="chart"
               :style="`font-size:${20*$store.state.ratio.hole}px`"><img src="../../../assets/imgs/tem.png"
                 :style="`width:${25*$store.state.ratio.width}px;height:${22*$store.state.ratio.height}px;top:${2*$store.state.ratio.height}px`" />温度:{{data.lastWeather.temperature}}</div>
          <div class="chart"
               :style="`font-size:${18*$store.state.ratio.hole}px`">{{date}} {{week}}</div>
        </div>
        <div class="flex">
          <div class="chart"
               :style="`font-size:${18*$store.state.ratio.hole}px;line-height:${30*$store.state.ratio.hole}px`"><img src="../../../assets/imgs/humidity.png"
                 :style="`width:${25*$store.state.ratio.width}px;height:${22*$store.state.ratio.height}px;top:${2*$store.state.ratio.height}px`" />湿度:{{data.lastWeather.humidity}}</div>
          <div class="chart "
               :style="`font-size:${18*$store.state.ratio.hole}px;line-height:${30*$store.state.ratio.hole}px`"><img src="../../../assets/imgs/wind.png"
                 :style="`width:${25*$store.state.ratio.width}px;height:${22*$store.state.ratio.height}px;top:${6*$store.state.ratio.height}px`" /> 风力风向:{{data.lastWeather.wind}}</div>

        </div>
        <card :width='`${parseFloat(width.card)*2}px`'
              :height="height.card"
              class="relative">
          <div :style="`font-size:${18*$store.state.ratio.hole}px`"
               class="asbolute"><img src="../../../assets/imgs/rain.png"
                 :style="`width:${25*$store.state.ratio.width}px;height:${22*$store.state.ratio.height}px;top:${2*$store.state.ratio.height}px`" />降雨量</div>
          <barDiagram :barData='data.rainarr'
                      single='true'
                      x='时'
                      y='mm' />
        </card>
        <div class="liner"
             :style="`font-size:${14*$store.state.ratio.hole}px`">基地实施气象监控</div>
        <div class="flex">
          <div class="chart">
            <card :width='width.card'
                  :height="height.card"
                  name="光照"
                  class="margin">
              <lineChart :width='width.slot'
                         :height="height.slot"
                         :series='data.light'
                         y='Lx' />
            </card>
          </div>
          <div class="chart">
            <card :width='width.card'
                  :height="height.card"
                  name="气压"
                  class="margin">
              <lineChart :width='width.slot'
                         :height="height.slot"
                         :series='data.airPressure'
                         y='hPa' />
            </card>
          </div>

        </div>
        <div class="flex">
          <div class="chart">
            <card :width='width.card'
                  :height="height.card"
                  name="温度"
                  class="margin">
              <lineChart :width='width.slot'
                         :height="height.slot"
                         :series='data.temperature'
                         y='°C' />
            </card>
          </div>
          <div class="chart">
            <card :width='width.card'
                  :height="height.card"
                  name="湿度"
                  class="margin">
              <lineChart :width='width.slot'
                         :height="height.slot"
                         :series='data.humidity'
                         y='%' />
            </card>
          </div>

        </div>
      </div>
      <div class='chart'
           :style='`height:${height.hole}`'>
        <monitoring />
        <!-- <div class="flex">
          <div class="chart"
               :style="`height:${height.monitoring}`">
            <video autoplay="autoplay"
                   loop="loop"
                   class="video_cage">
              <source class="video"
                      title="主监控位"
                      src="http://dev.svideo.com.cn:1880/hlslive/50148.m3u8" />
            </video>
          </div>
          <div class="chart"
               :style="`height:${height.monitoring}`"></div>

        </div>
        <div class="flex">
          <div class="chart"
               :style="`height:${height.monitoring}`"></div>
          <div class="chart"
               :style="`height:${height.monitoring}`"></div>
        </div> -->
      </div>

    </div>
  </div>

</template>
<script>
import card from '../../../components/common/card.vue'
import api from '../api'
import setting from '../setting'
import monitoring from '../../../components/common/monitoring.vue'
export default {
  components: {
    card, monitoring
  },
  data () {
    return {
      width: {
        hole: '',
        card: "",
        monitoring: ''//监控
      },
      height: {
        hole: '',
        card: '',
        head: '',
        slot: ''
      },
      data: {
        light: [],
        airPressure: [],
        temperature: [],
        humidity: [],
        rainarr: [],
        lastWeather: {}
      },
      lock: true,
      date: "",
      week: ''
    }
  },
  created () {
    let self = this
    this.getNowFormatDate()
    this.getOneDay()
    const width = document.body.clientWidth
    const height = document.body.clientHeight
    this.width.hole = width + 'px'
    this.getHeadHeight(height)
    this.getMonitoring(height)
    this.height.hole = height - parseFloat(this.height.head) + 'px'
    this.getcardWidth(width, height)
    this.getData()
    let interval = setInterval(self.getData, setting.requestTime);
    interval
  },
  methods: {
    getcardWidth (width, height) {
      this.width.card = (width - 4) / 4 - 6 + 'px'
      this.height.card = (height - parseFloat(this.height.head) - 2) / 3.5 - 30 + 'px'
      this.height.slot = parseFloat(this.height.card) * 0.9 + 'px'
    },
    getMonitoring (height) {
      this.height.monitoring = (height - parseFloat(this.height.head) - 4) / 2 + 'px'
    },
    getHeadHeight (height) {
      this.height.head = 0.1 * height + 'px'
    },
    carousel () {
      this.$store.commit('setLock')
      this.$emit('carousel')
    },
    getNowFormatDate () {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      this.date = currentdate;
    },
    getOneDay (y, m, d) {
      var now = new Date();
      var day = now.getDay();
      var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
      var week = weeks[day];
      this.week = week;
    },
    getData () {
      api.getQueryLastWealther().then(res => {

        this.data.light = res.light
        this.data.airPressure = res.airPressure
        this.data.temperature = res.temperature
        this.data.humidity = res.humidity
        this.data.rainarr = res.rainarr
        this.data.lastWeather = res.lastWeather
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  position: relative;
  .headImg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .head-item {
    flex: 1;

    text-align: center;
    position: relative;
    line-height: 50px;
    font-size: 18px;
    img {
      position: absolute;
      top: 35%;
      right: 3%;
    }
  }
}
.flex {
  display: flex;
  .chart {
    flex: 1;
    img {
      display: inline;
      position: relative;
    }
  }
  .flexed {
    flex: 2;
  }
  .margin {
    margin-top: 2%;
  }
}
.liner {
  text-align: center;
  background-image: linear-gradient(
    to right,
    rgb(17, 24, 57) 10%,
    rgb(24, 46, 106) 20%,
    rgb(17, 24, 57) 90%
  );
}
.video_cage {
  width: 100%;
  height: 100%;
}
.asbolute {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center !important;
}
.relative {
  position: relative;
}
</style>